import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { BoolInput } from '../../atoms/bool-input.component';
import type { BoolInputProps } from '../../layouts/types';
import { SwitchStyles } from './switch.styles';

export const Switch = ({ active, disabled, error, value, indeterminate, ...rest }: BoolInputProps<'switch'>) => {
  const style = SwitchStyles.switch({ disabled, active, error, value, indeterminate });
  return (
    <div css={style}>
      {indeterminate && (
        <Icon name='minus' color='primary' className='icon' onClickCapture={(e) => e.preventDefault()} />
      )}
      <BoolInput
        css={css`
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
        `}
        {...rest}
        type='checkbox'
        checked={value}
        disabled={disabled}
      />
    </div>
  );
};
